export const TEMPLATE_CATEGORIES = [
  { value: 'general', label: 'Ogólne' },
  { value: 'product', label: 'Produkt' },
  { value: 'other', label: 'Inne' },
] as const;

export type TemplateCategoryValue = typeof TEMPLATE_CATEGORIES[number]['value'];

export function normalizeTemplateCategory(value: unknown): TemplateCategoryValue {
  return TEMPLATE_CATEGORIES.some((category) => category.value === value)
    ? value as TemplateCategoryValue
    : 'other';
}

export function templateCategoryLabel(value: unknown): string {
  return TEMPLATE_CATEGORIES.find((category) => category.value === value)?.label ?? 'Inne';
}
